const state = {
    options:[],
};

const getters = {
    options: state => state.options,
};

const actions = {
    getOptions({commit, state}){
        axios.get('/api/admin/option').then((response) => {
            commit('setOptions', response.data.data);
        })
    }
};

const mutations = {
    setOptions(state, options){
        state.options = options;
    }
};

export default {
    state,
    getters,
    actions,
    mutations
}